import React from "react";
import { AuthZTable } from "../../../../../components/authZTable";
import useGetUserListColumnsConfiguration from "../../../userList/hooks/GetUserListColumnsConfiguration/GetUserListColumnsConfiguration";

function UserInfo({ userDetails }) {
  let columns = useGetUserListColumnsConfiguration();
  columns = columns.filter((column) => column.title !== "User");
  columns = columns.map((column) => {
    return {
      title: column.title,
      dataIndex: column.dataIndex,
      key: column.key,
      sortEnabled: false,
      searchEnabled: false,
    };
  });
  return (
    <div className="user-info-container">
      <AuthZTable
        name="user-group-list"
        rowKey="key"
        dataSource={[userDetails]}
        columns={columns}
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
}

export default UserInfo;
